import {gql} from '@apollo/client';

export const Version_QUERY = gql`
  query Version {
    version
  }
`;
